export enum SimNao {
    SIM = 'S',
    NAO = 'N'
}
